import { render, staticRenderFns } from "./ZimbraSharedDomain.vue?vue&type=template&id=d798c280&"
import script from "./ZimbraSharedDomain.vue?vue&type=script&lang=js&"
export * from "./ZimbraSharedDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports